import clsx from "clsx";
import { graphql } from "gatsby";
import React, { FC } from "react";

import { useFormattedDate } from "../../hooks/use-formatted-date";
import { CompanyEventSchedule } from "./company-event-schedule";

export interface CompanyEventProps extends Queries.CompanyEventDataFragment {}

export const CompanyEvent: FC<CompanyEventProps> = ({ eventDate, eventSchedule }) => {
  const formattedDay = useFormattedDate(eventDate, { day: "2-digit" });
  const formattedMonth = useFormattedDate(eventDate, { month: "short" });

  return (
    <div
      className={clsx(
        "w-full border border-primary-light bg-light rounded-lg overflow-hidden",
        "flex flex-col md:flex-row items-stretch"
      )}
    >
      <div className="flex md:flex-col flex-shrink-0 md:w-24 text-center">
        <div className="bg-primary font-medium text-white text-3xl py-2 flex-[1_1_50%] md:flex-none">
          {formattedDay}
        </div>
        <div
          className={clsx(
            "bg-primary-light font-medium text-dark text-xl",
            "py-3 md:h-full flex items-center justify-center md:items-start flex-[1_1_50%] md:flex-auto"
          )}
        >
          {formattedMonth.toUpperCase()}
        </div>
      </div>
      <div className="p-6 flex flex-col gap-4 md:gap-3">
        {eventSchedule?.map(
          (scheduleProps, index) =>
            scheduleProps && <CompanyEventSchedule key={index} {...scheduleProps} />
        )}
      </div>
    </div>
  );
};

export const query = graphql`
  fragment CompanyEventData on ContentfulCompanyEvent {
    eventDate
    eventSchedule {
      ...CompanyEventScheduleData
    }
  }
`;
